import React, { useEffect, useState } from 'react';
import { ClockIcon, FlameIcon } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50); // 14:50 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-1 px-4 z-50 shadow-lg" data-id="element-323">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center flex-wrap" data-id="element-324">
        <div className="flex items-center gap-1.5 font-bold text-sm" data-id="element-325">
          <ClockIcon className="w-4 h-4" data-id="element-326" />
          <span data-id="element-327">OFERTA EXPIRA EN:</span>
          <span className="text-base md:text-lg tabular-nums" data-id="element-328">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>
        <div className="flex items-center gap-1.5 font-bold text-sm" data-id="element-329">
          <FlameIcon className="w-4 h-4" data-id="element-330" />
          <span data-id="element-331">SOLO QUEDAN 3 CUPOS</span>
        </div>
      </div>
    </div>;
}